
angular.module('ui.simpleModal')
	.controller("SimpleModalCtrl", SimpleModalCtrl);

SimpleModalCtrl.$inject = ['$scope', '$uibModalInstance', '$controller', 'config'];

function SimpleModalCtrl($scope, $uibModalInstance, $controller, config) {

	$scope.templateUrl	= config.templateUrl;	// Template's URL to load in modal window
	$scope.text			= config.text;			// Text to show in modal window (if templateUrl is not defined)
	$scope.html			= config.html;			// HTML to show in modal window (if templateUrl is not defined)
	$scope.title		= config.title;			// Title of modal window
	$scope.data			= config.data;			// Data to path to template
	$scope.config		= config.config;		// Configuration variables
	$scope.buttons		= config.buttons;		// Array of buttons. Each button is like
												// 		{
												// 			'name':   'name_of_button',		// will be returned as result
												// 			'text':   'Buttons text',		// text on button
												// 			'class':  'btn-success',		// Class of button
												// 			'cancel': false					// if true - button will dismiss modal
												// 		}
	
	var modalName = config.modalName;
	// extend controller
	var parentCtrl = $controller('VerySimpleModalCtrl', {
		$scope: $scope,
		$uibModalInstance: $uibModalInstance
	});
	// Methods:
	// 		$scope.ok()
	// 		$scope.cancel()
	// Events:
	// 		$scope.$on('$stateChangeStart')


	// Action on cancel of modal
	$scope.cancel = function (button) {
		var reason = 'cancel';

		if(angular.isDefined(button) && angular.isDefined(button.name)){
			reason = button.name;
		}

		$uibModalInstance.dismiss(reason);
	};

	// Process button click
	$scope.buttonClick = function(button){
		if(angular.isString(button)){
			button = {
				'name':   button,
				'cancel': false
			}
		}
		
		if(button.cancel){
			$scope.cancel(button);
		}else{
			var result = button.name;
			
			if(config.returnData == true){
				result = {
					'button': button.name,
					'data':   $scope.data
				}
			}
			
			$uibModalInstance.close(result);
		}
	};
	
	$scope.$on('uiSimpleModal:close', function(event, result){
		$uibModalInstance.close(result);
	});
	
	$scope.$on('uiSimpleModal:dismiss', function(event, reason){
		$uibModalInstance.close(reason);
	});
	
	$scope.$on('uiSimpleModal:buttonClick', function(event, button){
		$scope.buttonClick(button);
	});
	
	$scope.$on('uiSimpleModal:cancel', function(event, button){
		$scope.cancel(button);
	});

	if(angular.isString(modalName)){
		
		$scope.$on('uiSimpleModal:close:' + modalName, function(event, result){
			$uibModalInstance.close(result);
		});
		
		$scope.$on('uiSimpleModal:dismiss:' + modalName, function(event, reason){
			$uibModalInstance.close(reason);
		});
		
		$scope.$on('uiSimpleModal:buttonClick:' + modalName, function(event, button){
			$scope.buttonClick(button);
		});
		
		$scope.$on('uiSimpleModal:cancel:' + modalName, function(event, button){
			$scope.cancel(button);
		});
	}
	
}

